import React from 'react';

export const WixDesignSystemContext = React.createContext<{
  newColorsBranding?: boolean;
  newBrandingClass?: string;
  mobile?: boolean;
}>({
  newColorsBranding: true,
  newBrandingClass: 'no-brand',
  mobile: false,
});
